













































































































































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { timeout } from '@/utils/common'
import AntecipacaoRecebiveisStore from '../RemuneracaoMedica/financeiro/Store/AntecipacaoRecebiveisStore'

type AttentionMessage = {
  title: string
  subtitle: string
} | null

@Component({ name: 'AntecipacaoProfissional' })
export default class AntecipacaoProfissional extends Vue {
  @Prop({ type: Number, default: 0 }) readonly availableCredit!: number
  @Prop({ type: Number, default: 0.0249 }) readonly interestRate!: number
  @Prop({ type: [String, Date], default: () => new Date('2025-10-20') })
  readonly dueDate!: string | Date

  requested: number = 0
  phone: string = ''
  bestTime: string = ''
  loadingVal: boolean = false
  formContatoValido: boolean = false

  rules = {
    phone: [
      (v: string) => !!(v && v.trim()) || 'Informe a preferência de contato'
    ],
    bestTime: [
      (v: string) => !!(v && v.trim()) || 'Informe o melhor horário para contato'
    ]
  }

  get getAntecipacaoStore() {
    return getModule(AntecipacaoRecebiveisStore, this.$store)
  }

  get getModalAntecipacao() {
    return this.getAntecipacaoStore.showAntecipacao
  }

  set getModalAntecipacao(v: boolean) {
    this.getAntecipacaoStore.setShowAntecipacao(v)
  }

  get valorOfertado() {
    return this.getAntecipacaoStore.antecipacaoProfissional.valorOfertado
  }

  get valorSolicitado() {
    return this.getAntecipacaoStore.antecipacaoProfissional.valorSolicitado
  }

  set valorSolicitado(v: number) {
    this.getAntecipacaoStore.setValorSolicitado(v)
  }

  get disableSolicitarContato(): boolean {
    const status = this.statusSolicitacao.toLowerCase()
    if (status !== 'liberado') {
      return true
    }
    return false
  }

  get statusSolicitacao(): string {
    const data = this.getAntecipacaoStore.antecipacaoProfissional
    return data && data.situacao ? String(data.situacao) : ''
  }

  get attentionMessage(): AttentionMessage {
    const status = this.statusSolicitacao.toLowerCase()

    if (!status) {
      return null
    }

    if (status === 'solicitado') {
      return {
        title: 'Solicitação enviada',
        subtitle: 'Aguarde o contato do consultor Fin-X.'
      }
    }

    if (status === 'negociacao') {
      return {
        title: 'Solicitação em negociação',
        subtitle: 'Sua solicitação está em negociação. Aguarde retorno do consultor Fin-X.'
      }
    }

    if (status === 'aprovado') {
      return {
        title: 'Crédito aprovado',
        subtitle: 'Crédito aprovado! Aguarde a liberação conforme orientações do consultor.'
      }
    }

    if (status === 'reprovado') {
      return {
        title: 'Solicitação não aprovada',
        subtitle: 'Solicitação não aprovada. Caso deseje mais detalhes, fale com o consultor Fin-X.'
      }
    }

    return null
  }

  get custoAntecipacao(): number {
    return +(this.requested * this.interestRate).toFixed(2)
  }

  get recebeHoje(): number {
    return Math.max(this.requested - this.custoAntecipacao, 0)
  }

  get dueDateFmt(): string {
    const d = new Date(this.dueDate as any)
    return new Intl.DateTimeFormat('pt-BR', {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    }).format(d)
  }

  get loading(): boolean {
    return this.loadingVal
  }

  set loading(v: boolean) {
    this.loadingVal = v
  }

  toCurrency(value: number): string {
    const n = Number.isFinite(value) ? value : 0
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n)
  }

  handleCurrencyInput(val: number | string) {
    let numericValue = 0

    if (typeof val === 'number') {
      numericValue = val
    } else {
      const digits = (val || '').replace(/\D/g, '')
      if (digits) {
        numericValue = Number(digits) / 100
      }
    }

    if (numericValue > this.valorOfertado) {
      this.requested = this.valorOfertado
    } else {
      this.requested = Math.max(0, numericValue)
    }
  }

  async handleSubmit() {
    const form = this.$refs.formContato as any

    const isValid = form ? form.validate() : true

    if (!isValid) {
      return
    }

    this.loading = true

    const payload = {
      valorSolicitado: this.requested,
      preferenciaContato: this.phone || null,
      melhorHorarioContato: this.bestTime || null
    }

    const response = await this.getAntecipacaoStore.submitAntecipacaoProfissional(payload)
    if (response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Solicitação enviada com sucesso! Em breve entraremos em contato.',
        icon: 'done',
        color: '#2E7D32'
      })
      this.getModalAntecipacao = false
      await timeout(1000)
    }

    this.loading = false
  }

  mounted() {
    this.requested = this.availableCredit
  }

  @Watch('availableCredit', { immediate: true })
  onCreditChange(val: number) {
    this.requested = val
  }
}
